import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCurrentPage } from 'reducers/ui';
import { PAGE_NAME } from 'utils/constants';
import { getSitesEnabled } from 'reducers/securityCompany';
import { actions as globalActions } from 'slices/globalOptions';

import { siteSelectors } from 'containers/Pages/Locations/Sites';
const { fetchGlobalSitesList } = globalActions;

const useSites = () => {
  //--------------------------Selectors--------------------------//
  const sites = useSelector(state =>
    siteSelectors.getSiteListTransformed(state),
  );
  const currentPage = useSelector(state => getCurrentPage(state));
  const sitesEnabled = useSelector(state => getSitesEnabled(state));
  const forceRefresh = useSelector(state =>
    siteSelectors.getForceRefresh(state),
  );
  //----------------------actions--------------------------------//
  const dispatch = useDispatch();

  useEffect(() => {
    if (!sitesEnabled || currentPage === PAGE_NAME.REGION) {
      return;
    }
    if (forceRefresh) {
      dispatch(
        fetchGlobalSitesList({
          filters: {},
          from: 0,
          allUnarchived: true,
        }),
      ); // fetch all the sites
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [forceRefresh, sitesEnabled]);

  return sites;
};

export default useSites;
